export default "data:text/javascript;base64,ZXhwb3J0ICogZnJvbSAiLi9wcmltYXJ5TmF2SXRlbXMuanMiOwoKZXhwb3J0IGRlZmF1bHQge307Cg=="